export const AFFILIATED_MROS = [
  'AMCOS',
  'CAPASSO',
  'MCPS',
  'MLC',
  'SAMRO',
  'SAYCO',
  'UNISON',
]

export const AFFILIATED_PROS = [
  'APRA',
  'ASCAP',
  'BMI',
  'CAPASSO',
  'PRS',
  'SAMRO',
  'SAYCO',
  'SOCAN',
  'UBC',
  'UNISON',
]
